import Vue from 'vue'
import Router from 'vue-router'
import { storage } from '@/services'

import { routes as publics }    from './public'
import { routes as privates }  from './privates'

Vue.use(Router)

const router = new Router({
	// mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/'
		},
        ...publics,
        ...privates
	],
})


router.beforeEach( async (to, from, next) => {
    let user = storage.read('user')
    
    if(to.meta.private){
        setTimeout(function(){
            if(!user){
                next('/')
                return false
            }

            user = JSON.parse(user)
            let permissions = Object.keys(user.caps)


            if(user.block === 1){
                storage.remove('user')
                storage.remove('user-token')

                router.push({
                    name: 'block',
                    params: {
                        title: 'Acesso não permitido',
                        text: 'Você foi bloqueado temporariamente. Entre em contato para mais informações.',
                    }
                })
                return false
            }

            if(to.meta.permission){

                if(to.meta.permission.some(i => permissions.includes(i))){
                    next()
                }else{
                    router.push({
                        name: 'access-block',
                        params: {
                            title: 'Acesso não permitido',
                            text: 'Você não tem permissão para acessar essa página',
                        }
                    })

                    return false
                }
            }

            next()

        }, 200)
    }else{
        next()
    }
})

export default router
